<template>
  <div class="sal-portal-container">
    <div class="version-ctrl-panel-container">
      <div id="sal-version" class="version">{{ version }}</div>
      <dat-gui id="control-panel" close-text="Close controls" open-text="Open controls" close-position="bottom"
        :open="false">
        <dat-select v-model="pdfPrintConfig.pdfOrientation" :items="pdfOrientations" label="orientation" />
        <dat-select v-model="pdfPrintConfig.pdfFormat" :items="pdfFormats" label="PDF Format" />
      </dat-gui>
    </div>
    <!-- <pdf-esg-app :pdf-print-config="pdfPrintConfig"></pdf-esg-app> -->
    <component v-if="componentLoaded && gmbComponent" :is="gmbComponent" :pdf-print-config="pdfPrintConfig">
    </component>
  </div>
</template>

<script>

import { useRoute } from 'vue-router';
import { ref, defineAsyncComponent, onMounted } from 'vue';

import "@pdf/core";
import Utils from "../utils"
import EnvLauncher from '../mixins/EnvLauncher'

export default {
  name: 'EsgReport',
  mixins: [EnvLauncher],
  components: {
  },
  setup() {
    const route = useRoute();
    const shareClassId = route.query.shareClassId;
    const securityType = route.query.securityType;
    const fundServCode = route.query.fundServCode;
    const pdfOrientations = Utils.pdfOrientations;
    const pdfFormats = Utils.pdfFormats;
    const version = ref("");
    const componentLoaded = ref(false);
    const gmbComponent = ref(null);
    const isGuiClosed = ref(true); // Control the GUI closed state
    const pdfPrintConfig = ref({
      pdfHeaderText: undefined,
      pdfFooterText: undefined,
      pdfOrientation: "portrait",
      pdfFormat: "Letter",
    });


    const applicationConfig = {
      integration: {
        id: "PDF-DEMO-APP",
      },
      investment: {
        id: shareClassId,
        type: securityType,
        marketUserGroup: "",
        fundServCode,
      },


      labels: {},
      components: {
        SalBasicPage: {
          type: "@pdf/esg",
          settings: {},
          labels: {},
        },
      },
    };
    window.sal.configuration.setAppConfig(applicationConfig);

    // This method can be improved to avoid code duplication across different components
    const loadGmbComponent = async () => {
      const host = `${window.location.protocol}//${window.location.host}`;
      let cdnUrl = `${host}/mf3/latest/pdf-esg-app.js`;

      if (host.includes("pdfportal-stg")) {
        const pathName = window.location.pathname;
        const match = pathName.match(/(\d+\.)(\d+\.)(\d+)/);
        cdnUrl = match
          ? `${host}/mf3/v${match[0]}/pdf-esg-app.js`
          : `${host}/mf3/latestRC/pdf-esg-app.js`;
      }
      if (host.includes("pdfportal-uat")) {
        cdnUrl = `${host}/mf3/latestRC/pdf-esg-app.js`;
      }
      if (host.includes("pdfportal-dev") || host.includes("pdfportal-qa")) {
        cdnUrl = `${host}/mf3/latestCI/pdf-esg-app.js`;
      }
      if (host.includes("localhost")) {
        // Added temporaryly for local testing with CDN
        cdnUrl = "https://pdfportal-qa.psp98d75.easn.morningstar.com/mf3/latestCI/pdf-esg-app.js";
      }

      try {
        // Load CDN first - make Vue available globally for UMD build
        const vue = await import('vue');
        window.Vue = vue;
        await Utils.salImport(cdnUrl);

        if (window["pdf-esg-app"]) {
          const component = window["pdf-esg-app"].default || window["pdf-esg-app"];
          if (component) {
            gmbComponent.value = component;
            componentLoaded.value = true;
            return;
          }
        }

        throw new Error("CDN component not available");

      } catch (error) {
        // Fallback to node_modules
        try {
          const moduleImport = await import("@pdf/esg-app");
          const component = moduleImport.default || moduleImport;

          if (component) {
            gmbComponent.value = component;
            componentLoaded.value = true;
          } else {
            throw new Error("Failed to load component from both CDN and node_modules");
          }
        } catch (fallbackError) {
          console.error("Component loading failed:", fallbackError);
        }
      }
    };

    onMounted(async () => {
      await loadGmbComponent();
    });

    return {
      shareClassId,
      pdfOrientations,
      pdfPrintConfig,
      pdfFormats,
      componentLoaded,
      gmbComponent,
      version
    }
  }
}
</script>

<style></style>